export default "__VITE_ASSET__Cfa_12SE__"